document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('[data-ir-av-section]')
  if (!sections.length) return

  const getYouTubeId = url => {
    try {
      const u = new URL(url)
      if (u.hostname.includes('youtu.be')) return u.pathname.slice(1)
      return u.searchParams.get('v')
    } catch {
      return ''
    }
  }

  const openItem = (item, panel, trigger) => {
    item.classList.add('is-open')
    trigger.setAttribute('aria-expanded','true')
    panel.style.maxHeight = panel.scrollHeight + 'px'
  }

  const closeItem = (item, panel, trigger) => {
    item.classList.remove('is-open')
    trigger.setAttribute('aria-expanded','false')
    panel.style.maxHeight = '0px'
  }

  sections.forEach(section => {

    const acc = section.querySelector('[data-ir-av-accordion]')
    if (acc) {
      const items = [...acc.querySelectorAll('[data-ir-av-item]')]

      items.forEach(item => {
        const trigger = item.querySelector('[data-ir-av-trigger]')
        const panel = item.querySelector('[data-ir-av-panel]')

        const expanded = trigger.getAttribute('aria-expanded') === 'true'
        panel.style.maxHeight = expanded ? panel.scrollHeight + 'px' : '0px'

        trigger.addEventListener('click', () => {
          const isCurrentlyOpen = trigger.getAttribute('aria-expanded') === 'true'

          items.forEach(i => {
            closeItem(
              i,
              i.querySelector('[data-ir-av-panel]'),
              i.querySelector('[data-ir-av-trigger]')
            )
          })

          if (!isCurrentlyOpen) {
            openItem(item, panel, trigger)
          }
        })
      })

      window.addEventListener('resize', () => {
        items.forEach(item => {
          const trigger = item.querySelector('[data-ir-av-trigger]')
          const panel = item.querySelector('[data-ir-av-panel]')
          if (trigger.getAttribute('aria-expanded') === 'true') {
            panel.style.maxHeight = panel.scrollHeight + 'px'
          }
        })
      })
    }

    const media = section.querySelector('[data-ir-av-media]')
    if (!media) return

    const playBtn = media.querySelector('[data-ir-av-play]')
    const videoWrap = media.querySelector('[data-ir-av-video-wrap]')
    const iframeWrap = media.querySelector('[data-ir-av-iframe-wrap]')
    const iframe = media.querySelector('[data-ir-av-iframe]')

    playBtn?.addEventListener('click', () => {
      playBtn.style.display = 'none'
      media.classList.add('is-loaded')

      if (videoWrap) {
        videoWrap.hidden = false
        const v = videoWrap.querySelector('video')
        v.muted = true
        v.controls = true
        v.play().catch(()=>{})
        return
      }

      if (iframeWrap && iframe) {
        const raw = iframeWrap.dataset.youtube
        if (!raw) return

        const id = getYouTubeId(raw)
        if (!id) return

        iframe.src = `https://www.youtube.com/embed/${id}?autoplay=1&mute=1&rel=0&playsinline=1`
        iframeWrap.hidden = false
      }
    })
  })

  // IR Accordion Video Animation System
  class IRAccordionVideoAnimations {
    constructor() {
      this.animatedElements = [];
      this.init();
    }

    init() {
      // Wait for DOM to be ready
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.setupAnimations());
      } else {
        this.setupAnimations();
      }
    }

    setupAnimations() {
      // Find all elements with animation classes
      const animateElements = document.querySelectorAll('.ir-animate-fade-up, .ir-animate-slide-left, .ir-animate-slide-up');
      
      if (animateElements.length === 0) return;

      // Create intersection observer
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.animateElement(entry.target);
          }
        });
      }, {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
      });

      // Observe all animation elements
      animateElements.forEach(element => {
        observer.observe(element);
      });
    }

    animateElement(element) {
      const delay = parseInt(element.getAttribute('data-delay')) || 0;
      
      setTimeout(() => {
        element.classList.add('ir-animated');
        
        // Add special effects for specific elements
        if (element.classList.contains('ir-av__item')) {
          this.animateAccordionItem(element);
        }
        
        if (element.classList.contains('ir-av__media')) {
          this.animateVideoMedia(element);
        }
        
        if (element.classList.contains('ir-av__title')) {
          this.animateTitle(element);
        }
      }, delay);
    }

    animateAccordionItem(element) {
      const trigger = element.querySelector('.ir-av__trigger');
      const icon = element.querySelector('.ir-av__icon');
      const step = element.querySelector('.ir-av__step');
      const heading = element.querySelector('.ir-av__heading');
      
      setTimeout(() => {
        // Animate trigger elements
        if (step) {
          step.style.transform = 'scale(1.1)';
          setTimeout(() => {
            step.style.transform = 'scale(1)';
          }, 200);
        }
        
        if (heading) {
          heading.style.transform = 'translateX(10px)';
          setTimeout(() => {
            heading.style.transform = 'translateX(0)';
          }, 300);
        }
        
        if (icon) {
          icon.style.transform = 'scale(1.1) rotate(5deg)';
          setTimeout(() => {
            icon.style.transform = 'scale(1) rotate(0deg)';
          }, 250);
        }
      }, 200);
    }

    animateVideoMedia(element) {
      const posterBtn = element.querySelector('.ir-av__poster-btn');
      const playIcon = element.querySelector('.ir-av__play');
      
      setTimeout(() => {
        if (posterBtn) {
          posterBtn.style.transform = 'scale(1.05)';
          setTimeout(() => {
            posterBtn.style.transform = 'scale(1)';
          }, 300);
        }
        
        if (playIcon) {
          playIcon.style.transform = 'scale(1.2)';
          playIcon.style.opacity = '0.9';
          setTimeout(() => {
            playIcon.style.transform = 'scale(1)';
            playIcon.style.opacity = '1';
          }, 400);
        }
      }, 300);
    }

    animateTitle(element) {
      setTimeout(() => {
        element.style.transform = 'translateY(-10px)';
        element.style.color = '#CDAC83';
        setTimeout(() => {
          element.style.transform = 'translateY(0)';
          element.style.color = '#4B5646';
        }, 400);
      }, 200);
    }
  }

  // Initialize animations
  const irAccordionVideoAnimations = new IRAccordionVideoAnimations();
})
